module.exports = __webpack_public_path__ + "img/w-8-add.c17cdea9.png";